import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ExportPosCheckoutModal from '@shared/components/modals/export-pos-checkout-modal/export-pos-checkout-modal.vue';
import { Order } from '@accounting/interfaces/order';
import store from '@app/store';
import { PosSession } from '@pos/interfaces/pos-session';

@Component({
  components: {
    'bpc-export-pos-checkout-modal': ExportPosCheckoutModal,
  },
})
export default class ExportToPosCheckout extends Vue {
  $refs: {};

  @Prop({ type: Boolean, default: true }) readonly withConfirmationModal: boolean;

  exportCheckoutModalId: string;
  showExportPosCheckoutModal: boolean = false;
  exportingToPosCheckout: boolean = false;
  ordersAvailableToPosCheckout: Order[] = [];
  selectedOrdersToPosCheckout: Order[] = [];
  selectedContactIdToPosCheckout: number = null;
  selectedInvoiceIdToPosCheckout: number = null;
  selectedPriceCategoryIdToPosCheckout: number = null;
  selectedArticleIdToPosCheckout: number = null;

  get posCheckoutOpenTickets() {
    return this.$store.getters['pos/openTickets'];
  }

  get openPosSession(): PosSession {
    return this.$store.getters['pos/openPosSession'];
  }

  // This method can be override to add other types of entities like Articles.
  // FIXME Use an interface payableEntity to extract always the date in the same way for all entities that can be paid
  onExportToPosCheckout(item) {
    this.ordersAvailableToPosCheckout = item?.item?.orders;
    this.selectedContactIdToPosCheckout = item?.item?.attendee_id
      ? item?.item?.attendee_id
      : item?.item?.contact_id;
    this.selectedPriceCategoryIdToPosCheckout = item?.item?.price_category_id;
    this.openExportPosCheckoutModal();
  }

  onBulkExportToPosCheckout(items) {
    this.ordersAvailableToPosCheckout = [];
    items.forEach(item => {
      this.ordersAvailableToPosCheckout = this.ordersAvailableToPosCheckout.concat(
        item?.orders || [],
      );
    });
    this.openExportPosCheckoutModal();
  }

  openExportPosCheckoutModal() {
    this.showExportPosCheckoutModal = true;
  }

  closeExportPosCheckoutModal() {
    this.exportingToPosCheckout = false;
    this.showExportPosCheckoutModal = false;
    this.resetSelectedDataToPosCheckout();
  }

  async onConfirmExportPosCheckout() {
    this.exportingToPosCheckout = true;
    try {
      const previousCurrentTicketId = this.$store.getters['pos/currentTicketId'];
      const result = await store.dispatch('pos/addOrdersToTicketInvoice', {
        ordersToCheckout: this.selectedOrdersToPosCheckout,
        contact_id: this.selectedContactIdToPosCheckout,
        invoice_id: this.selectedInvoiceIdToPosCheckout,
        pos_session_id: this.openPosSession?.id,
        sale_day_id: this.openPosSession?.sale_day_id || null,
        price_category_id: this.selectedPriceCategoryIdToPosCheckout,
        article_id: this.selectedArticleIdToPosCheckout,
        in_pos_checkout: 1,
        invoice_type: 'ticket',
        action: 'askForBadge',
      });
      const el = document.body;

      const currentTicketId = this.$store.getters['pos/currentTicketId'];
      if (previousCurrentTicketId === currentTicketId) {
        this.$root.$emit('refresh-pos-order-items');
      }
      this.$root.$emit('refresh-table-after-add-orders-to-pos');
      this.$root.$emit('refresh-form-after-add-orders-to-pos');
      this.closeExportPosCheckoutModal();
      this.exportingToPosCheckout = false;
    } catch (e) {
      this.$bpcMessage.showErrorMessage({ text: 'global.pos.errors.adding_orders' });
      this.exportingToPosCheckout = false;
    }
  }

  async onConfirmAddArticleToCurrentPosTicket() {
    this.exportingToPosCheckout = true;
    try {
      const result = await store.dispatch('pos/addArticleToTicketInvoice', {
        invoice_id: this.selectedInvoiceIdToPosCheckout,
        pos_session_id: this.openPosSession?.id,
        article_id: this.selectedArticleIdToPosCheckout,
      });
      const currentTicketId = this.$store.getters['pos/currentTicketId'];
      // Add order items to the table to process and update its

      this.closeExportPosCheckoutModal();
      this.exportingToPosCheckout = false;
    } catch (e) {
      console.log('ERROR ', e);
      this.$bpcMessage.showErrorMessage({ text: 'global.pos.errors.adding_orders' });
      this.exportingToPosCheckout = false;
    }
  }

  onSelectOrdersToPosCheckout(orders) {
    console.log('Selected Orders ', orders);
    this.selectedOrdersToPosCheckout = orders;
  }

  onSelectInvoiceToPosCheckout(invoice) {
    console.log('Selected Invoice ', invoice);
    this.selectedInvoiceIdToPosCheckout = invoice?.id;
  }

  resetSelectedDataToPosCheckout() {
    this.selectedContactIdToPosCheckout = null;
    this.selectedInvoiceIdToPosCheckout = null;
    this.selectedPriceCategoryIdToPosCheckout = null;
    this.selectedOrdersToPosCheckout = [];
  }
}
